import React from 'react';
import SearchInput from '../../v2BaseComponents/SearchInput';
import { StyleProp, ViewStyle } from 'react-native';

export type SearchBarOwnProps = {
    value: string;
    onChange: (value: string) => void;
    testID?: string;
    placeholder: string;
    isDisabled?: boolean;
    style?: StyleProp<ViewStyle>;
};

export type SearchBarProps = SearchBarOwnProps;

const SearchBar: React.FC<SearchBarProps> = (props) => {
    return (
        <SearchInput
            style={[{ width: '100%' }, props.style]}
            placeholder={props.placeholder}
            value={props.value}
            onChange={props.onChange}
            testID={props.testID}
            isDisabled={props.isDisabled}
        />
    );
};

export default React.memo(SearchBar);
